class FitmentString {
  constructor(year, make, model, submodel, drive_type, fuel_type, doors, type) {
    this.year = year
    this.make = make
    this.model = model
    this.submodel = submodel
    this.drive_type = drive_type
    this.fuel_type = fuel_type
    this.doors = doors
    this.type = type
  }
}

function stringToObject(fitmentStrings) {
  let newStrArr
  let stringsToObjects = []
  newStrArr = fitmentStrings.split(';')
  newStrArr.forEach((str) => {
    let tempArr
    tempArr = str.split('|')
    let tempFitmentObject = new FitmentString()
    tempFitmentObject.year = tempArr[0]
    tempFitmentObject.make = tempArr[1]
    tempFitmentObject.model = tempArr[2]
    tempFitmentObject.submodel = tempArr[3]
    tempFitmentObject.drive_type = tempArr[4]
    tempFitmentObject.fuel_type = tempArr[5]
    tempFitmentObject.doors = tempArr[6]
    tempFitmentObject.type = tempArr[7]

    stringsToObjects.push(tempFitmentObject)
  })

  return stringsToObjects
}

function checkFitment(metafieldsArr, vehicle) {
  let isFitment = false
  if (metafieldsArr.length > 0 && !isEmpty(vehicle)) {
    metafieldsArr.forEach((item) => {
      if (
        item.year === vehicle.year &&
        (!item.make ||
          !vehicle.make ||
          item.make.toLowerCase() === 'x' ||
          item.make.toLowerCase() === vehicle.make.toLowerCase()) &&
        (!item.model ||
          !vehicle.model ||
          item.model.toLowerCase() === 'x' ||
          item.model.toLowerCase() === vehicle.model.toLowerCase()) &&
        (!item.submodel ||
          !vehicle.submodel ||
          item.submodel.toLowerCase() === 'x' ||
          item.submodel.toLowerCase() === vehicle.submodel.toLowerCase()) &&
        (!item.drive_type ||
          !vehicle.drive_type ||
          item.drive_type.toLowerCase() === 'x' ||
          item.drive_type.toLowerCase() === vehicle.drive_type.toLowerCase()) &&
        (!item.fuel_type ||
          !vehicle.fuel_type ||
          item.fuel_type.toLowerCase() === 'x' ||
          item.fuel_type.toLowerCase() === vehicle.fuel_type.toLowerCase()) &&
        (!item.doors ||
          !vehicle.doors ||
          item.doors.toLowerCase() === 'x' ||
          item.doors.toLowerCase() === vehicle.doors.toLowerCase()) &&
        (!item.type ||
          !vehicle.type ||
          item.type.toLowerCase() === 'x' ||
          item.type.toLowerCase() === vehicle.type.toLowerCase())
      ) {
        isFitment = true
      }
    })
  }

  return isFitment
}

const getCollectionJson = async (url, page) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${url}&page=${page}`,
      type: 'GET',
      success: function (data) {
        resolve(data)
      },
      error: function (error) {
        reject(error)
      },
    })
  })
}

const getAllCollectionData = async (url, total_pages) => {
  try {
    let html = ''
    const promises = []

    for (let i = 1; i <= total_pages; i++) {
      promises.push(getCollectionJson(url, i))
    }

    const dataResponses = await Promise.all(promises)

    dataResponses.forEach((data) => {
      html += data
    })

    return html
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

if (localStorage.getItem('fitment')) {
  var collectionProductGrid = document.getElementById('CollectionProductGrid')
  var mainCollectionProductGrid = document.getElementById(
    'main-collection-product-grid'
  )
  mainCollectionProductGrid.innerHTML = ''

  if (search_key) {
    getAllCollectionData(
      `${baseUrl}/search?q=${search_key}&view=alternative`,
      total_pages
    )
      .then((html) => {
        let i = 0
        var elements = Array.from(
          new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelectorAll('.search_product_item')
        )

        elements.forEach(function (element) {
          var fitmentData = stringToObject(element.dataset.str.slice(0, -1))
          var localStorageFitment = JSON.parse(localStorage.getItem('fitment'))

          if (checkFitment(fitmentData, localStorageFitment)) {
            i++
            mainCollectionProductGrid.appendChild(element)
          }
        })

        var paginationWrapper = document.querySelector('.pagination-wrapper')
        paginationWrapper.classList.add('hidden')
        var pageHeader = document.querySelector('.page-header')
        pageHeader.textContent = i + ' RESULTS FOUND FOR "' + search_key + '"'
      })
      .catch((error) => {
        console.error(error)
      })
  } else {
    getAllCollectionData(
      `${baseUrl}/collections/${collectionHandle}?view=alternative`,
      total_pages
    )
      .then((html) => {
        var elements = Array.from(
          new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelectorAll('.product-masonry-item')
        )

        elements.forEach(function (element) {
          var fitmentData = stringToObject(element.dataset.str.slice(0, -1))
          var localStorageFitment = JSON.parse(localStorage.getItem('fitment'))

          if (checkFitment(fitmentData, localStorageFitment)) {
            mainCollectionProductGrid.appendChild(element)
          }
        })

        var paginationWrapper = document.querySelector('.pagination-wrapper')
        paginationWrapper.classList.add('hidden')
      })
      .catch((error) => {
        console.error(error)
      })
  }
}
